const API_URL = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');

async function getJson(path) {
  const response = await fetch(`${API_URL}${path}`);
  if (!response.ok) throw new Error(`Error HTTP ${response.status}`);
  return response.json();
}

export async function loadCloudAccounts() {
  const accounts = [];
  let offset = 0;
  const limit = 1000;
  while (true) {
    const result = await getJson(`/gobierno-cloud/cloud-accounts/?limit=${limit}&offset=${offset}`);
    accounts.push(...result.data);
    if (accounts.length >= result.total || result.data.length === 0) return accounts;
    offset += result.data.length;
  }
}

export async function loadClientNames() {
  const clients = [];
  let offset = 0;
  const limit = 100;
  while (true) {
    const page = await getJson(`/finops/clientes?limit=${limit}&offset=${offset}`);
    if (!Array.isArray(page)) throw new Error('Formato de clientes inesperado');
    clients.push(...page);
    if (page.length < limit) return clients;
    offset += page.length;
  }
}

export function clientIds(client) {
  return String(client.sap_ids || '').split(',').map(id => id.trim()).filter(Boolean);
}